import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import rolodexLogo from './assets/rolodex.webp';
import { api } from './api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (!token) {
      setError('This reset link is missing or invalid.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const response = await api.post('/v1/auth/reset-password', { token, newPassword: password });
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data || 'This reset link is invalid or expired.');
    }
  };

  return (
    <div className="auth-screen" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', gap: 50 }}>
      <div className="auth-brand">
        <img src={rolodexLogo} alt="Digidex Logo" className="auth-logo" style={{ height: '7.5rem', width: '7.5rem', objectFit: 'contain' }} />
        <h1 style={{ fontSize: '2.15rem', fontWeight: 'bold', color: '#333' }}>Digidex</h1>
      </div>
      <form onSubmit={handleSubmit} className="auth-form" style={{ background: '#fff', padding: '2rem 2.5rem', borderRadius: '10px', boxShadow: '0 2px 16px rgba(0,0,0,0.07)', minWidth: '320px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '0.5rem', color: '#222' }}>Choose a new password</h2>
        {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
        {message && <div style={{ color: '#222', textAlign: 'center' }}>{message}</div>}
        {!message && <>
          <input placeholder="New password" type="password" value={password} onChange={event => setPassword(event.target.value)} required minLength={8} style={{ padding: '0.75rem', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem', background: '#fafafa', outline: 'none' }} />
          <input placeholder="Confirm new password" type="password" value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} required minLength={8} style={{ padding: '0.75rem', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem', background: '#fafafa', outline: 'none' }} />
          <button type="submit" style={{ padding: '0.75rem', border: 'none', borderRadius: '5px', background: '#222', color: '#fff', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' }}>Reset password</button>
        </>}
        <Link to="/login" style={{ textAlign: 'center', color: '#222' }}>Back to login</Link>
      </form>
    </div>
  );
}

export default ResetPassword;
